/**
 * Funktionsschalter: optionale Module, die ein Administrator je Instanz aktivieren oder
 * deaktivieren kann (Administration -> Funktionen). Ergänzt die Rollen-Berechtigungen: die Rolle
 * entscheidet, WER ein Modul nutzen darf, der Schalter, OB es auf dieser Instanz überhaupt aktiv ist.
 * Ein deaktiviertes Modul verschwindet aus der Navigation, seine API antwortet mit
 * FEATURE_DISABLED und zugehörige Cron-Jobs laufen leer durch. Daten bleiben erhalten.
 *
 * Neue Schalter: Schlüssel hier ergänzen, im API-Router requireFeature() vorschalten und den
 * Navigationspunkt in App.tsx mit feature markieren.
 */
export const FEATURE_KEYS = ["bmReports", "activityTimeline", "jiraConnections", "planning"];
export const FEATURE_DEFINITIONS = {
    bmReports: {
        label: "Business-Manager-Berichte",
        description: "Zweiwöchentlicher Bericht: Meine Berichte, Berichte der BM, Themenverantwortung und die Erinnerungs-E-Mails.",
    },
    activityTimeline: {
        label: "ActivityTimeline-Sync",
        description: "Stündlicher Abgleich der geplanten Auslastung aus Jira ActivityTimeline samt Verwaltungsseite.",
    },
    jiraConnections: {
        label: "Persönliche Jira-Verbindungen",
        description: "Jeder Benutzer kann eigene Jira-Zugangsdaten hinterlegen (Persönlich -> Meine Jira-Verbindungen).",
    },
    planning: {
        label: "Planung 2027",
        description: "Kapazitäts- und Szenarioplanung je Thema.",
    },
};
/**
 * Standard, solange ein Administrator nichts gespeichert hat: alle Module aktiv. So ändert das
 * Einführen der Schalter nichts am Verhalten bestehender Instanzen.
 */
export const DEFAULT_FEATURE_FLAGS = {
    bmReports: true,
    activityTimeline: true,
    jiraConnections: true,
    planning: true,
};
